import { render, staticRenderFns } from "./ExaminationRecordsAdd.vue?vue&type=template&id=18fd48a0&scoped=true&"
import script from "./ExaminationRecordsAdd.vue?vue&type=script&lang=js&"
export * from "./ExaminationRecordsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fd48a0",
  null
  
)

export default component.exports